import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    IonBackButton,
    IonButtons,
    withIonLifeCycle,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonSearchbar,
    IonGrid,
    IonRow,
    IonCol,
    IonLabel,
    IonItemDivider,
    IonList,
    IonItem,
    IonThumbnail,
    IonImg,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCardContent,
    IonIcon,
    IonButton,
    IonInfiniteScroll,
    IonInput,
    IonRange,
    IonFabList,
    IonText,
    IonInfiniteScrollContent, IonTextarea, IonFab, IonCheckbox, IonToggle, IonBadge, IonFabButton, IonAlert, IonSegment, IonSegmentButton, IonModal, IonFooter, IonSpinner, IonMenuButton
} from '@ionic/react';
import { home, starHalf, call, business, closeOutline, podium, save, trash, arrowUp, ellipsisVerticalOutline, add, homeOutline, cartOutline, person, addOutline, barcode } from 'ionicons/icons';
import { AnyARecord } from 'dns';
import './ContactModal.css';
import PosActions from '../../../actions/PosActions';
import Select from 'react-select'
import { getDepartamentos, getMunicipios, getLoginApp } from '../../../utils/functions';

const options2 = { style: 'currency', currency: 'USD' };
const _numberFormat = new Intl.NumberFormat('en-US', options2);
const _numberFormatClean = new Intl.NumberFormat('en-US', options2);

interface IProps {
    setData_: any;
    post_: any;

}
interface IState {
    show: any;
    contact: any;
    response: any;
    formErrors: any;
    ModalNotSellShow: any;
    fieldsNotSell: any;
    departamentos: any;
    municipios: any;
    datalogin: any;
    rutas: any;
    //dashboard_pos/cart
}
class ContactModal extends React.Component<IProps, IState> {
    ModalProfit: React.RefObject<HTMLIonModalElement>;
    ModalNotSell: React.RefObject<HTMLIonModalElement>;

    constructor(props: any) {
        super(props)
        this.ModalProfit = React.createRef<HTMLIonModalElement>();
        this.ModalNotSell = React.createRef<HTMLIonModalElement>();

        this.state = {

            show: props.show,
            contact: props.contact,
            response: props.response,
            formErrors: props.formErrors,
            ModalNotSellShow: props.ModalNotSellShow,
            fieldsNotSell: props.fieldsNotSell,
            rutas: props.rutas,

            departamentos: props.departamentos,
            municipios: props.municipios,
            datalogin: props.datalogin,

        };
    }

    componentDidMount() {
        this.setState({
            show: false,
            ModalNotSellShow: false,
            departamentos: getDepartamentos(),
            municipios: [],
            datalogin: getLoginApp(),
            contact: {},
            fieldsNotSell: {
                customer_id: null,
                contact_type_radio: 0,
                note: '',
                day: 1
            }
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            rutas: nextProps.data.data_default && nextProps.data.data_default.rutas ? nextProps.data.data_default.rutas : [],

        });
        if (nextProps.data.response && nextProps.data.response.success) {
            this.setState({
                show: false,
            });
        }
        //console.log("contactModal--------", nextProps.data.view_active);
    }

    handleShow(row: any) {
        if (row) {
            let slc_munipios: any = [];

            if (row.city) {
                slc_munipios = getMunicipios().filter((item_filter: any) => item_filter.padre.toUpperCase() == row.city.toUpperCase());
            }

            let day_visit = [];
            let day_visit_format: any = [];
            let tem_day = [
                { label: "Lunes", value: 1 },
                { label: "Martes", value: 2 },
                { label: "Miercoles", value: 3 },
                { label: "Jueves", value: 4 },
                { label: "Viernes", value: 5 },
                { label: "Sabado", value: 6 },
                { label: "Domingo", value: 0 },
            ];

            /*if (typeof row.day_visit === 'string') {
                day_visit = JSON.parse(row.day_visit_prev);
                day_visit.map((val: any, key_: any) =>
                    day_visit_format.push(tem_day.filter((item: any) => item.value == val)[0])
                );
                row.day_visit = day_visit_format;
            } else {
                if (row.day_visit) {
                    day_visit = JSON.parse(row.day_visit_prev);
    
                } else {
                    row.day_visit = [];
                }
            }*/
            day_visit = JSON.parse(row.day_visit_prev ? row.day_visit_prev : "[]");
            day_visit.map((val: any, key_: any) =>
                day_visit_format.push(tem_day.filter((item: any) => item.value == val)[0])
            );
            row.day_visit = day_visit_format;

            row.is_contado = row.is_contado == null || row.is_contado == 0 ? 1 : row.is_contado;

            this.setState({
                show: true,
                contact: row,
                fieldsNotSell: {
                    customer_id: row.id,
                    contact_type_radio: 0,
                    note: '',
                    day: row.day_visit
                },
                municipios: slc_munipios,
                formErrors: {}
            });
        } else {
            this.setState({
                show: true,
                contact: {
                    name: '',
                    is_contado: 1,
                    supplier_business_name: '',
                    mobile: '',
                    email: '',
                    tax_number: '',
                    city: '',
                    state: '',
                    day_visit: [],
                    shipping_address: '[null]',
                    ruta_id: null,
                    pay_term_number: null,
                    pay_term_type: null,
                },
                fieldsNotSell: {
                    customer_id: null,
                    contact_type_radio: 0,
                    note: '',
                    day: 1
                },
                formErrors: {}
            });
        }
    }

    onClosenModal() {
        this.setState({
            show: false,
        });
    }

    addRemovedShipping_Address(action: any, row: any, key: any) {
        let contact = this.state.contact;
        let new_data: any = [];
        if (action == "add") {
            new_data = contact.shipping_address ? JSON.parse(contact.shipping_address) : [];
            new_data.push('');
        } else {
            contact.shipping_address && JSON.parse(contact.shipping_address).map((val: any, key_: any) =>
                key_ != key ?
                    new_data.push(val)
                    : null
            );
        }
        contact['shipping_address'] = JSON.stringify(new_data);
        this.setState({
            contact: contact
        });
    }

    rendershipping_address(row: any) {
        let array_dir = row.shipping_address ? JSON.parse(row.shipping_address) : [''];
        let render_shipping_address: any = [];

        array_dir.map((val: any, key: any) => {
            {
                key == 0 ?
                    render_shipping_address.push(
                        <IonCol col-12 size='12' key={key}>
                            <label>{"Dirección " + (key + 1)}: </label>
                            <div className="inputWithIcon">
                                <IonIcon slot="start" className='inputWithIconIcono' icon={home} aria-hidden="true"></IonIcon>
                                <input className='inputform'
                                    type="text" placeholder={"Dirección " + (key + 1)}
                                    onChange={(e) => this.onChangeForValuesDetailsArray(key, { target: { name: "shipping_address", value: e.target.value } })}
                                    value={val ?? ""}
                                    name="custom_field10" />
                                <IonButton size="small" onClick={(ev) => this.addRemovedShipping_Address('add', array_dir, key)}><IonIcon icon={addOutline}></IonIcon></IonButton>
                            </div>
                        </IonCol>
                    )
                    :
                    render_shipping_address.push(
                        <IonCol col-12 size='12' key={key}>
                            <label>{"Dirección " + (key + 1)}: </label>
                            <div className="inputWithIcon">
                                <IonIcon slot="start" className='inputWithIconIcono' icon={home} aria-hidden="true"></IonIcon>
                                <input className='inputform'
                                    type="text" placeholder={"Dirección " + (key + 1)}
                                    onChange={(e) => this.onChangeForValuesDetailsArray(key, { target: { name: "shipping_address", value: e.target.value } })}
                                    value={val ?? ""}
                                    name="custom_field10" />
                                <IonButton size="small" color={'danger'} onClick={(ev) => this.addRemovedShipping_Address('removed', array_dir, key)}>-</IonButton>
                            </div>
                        </IonCol>
                    );
            }

        });
        return render_shipping_address;
    }

    SaveDataPost() {
        let contact = this.state.contact;

        let error = false;
        let formErrors: any = {};
        if (this.state.contact && this.state.contact.name == "") { formErrors['name'] = "*Campo Requerido"; error = true };
        if (this.state.contact && this.state.contact.mobile == "") { formErrors['mobile'] = "*Campo Requerido"; error = true };

        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {
            let day_visit_format: any = [];
            this.state.contact.day_visit.map((val: any, key_: any) =>
                day_visit_format.push(val.value)
            );
            this.state.contact.day_visit_format = day_visit_format;
            if (contact.id) {
                this.props.post_({
                    typeOption: 'saveDataContact',
                    action: 'update',
                    contact: this.state.contact,
                    user_id: this.state.datalogin.id,
                    view_active: 'dashboard_pos/contacts'
                }, "api/saveDataContact");
            } else {
                this.props.post_({
                    typeOption: 'saveDataContact',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    contact: this.state.contact,
                    view_active: 'dashboard_pos/contacts'
                }, "api/saveDataContact");
            }
        }
    }

    handleChange(event: any) {
        let contact = this.state.contact;
        console.log(event.target.name, event.target.value);
        contact[event.target.name] = event.target.value;

        let slc_munipios: any = [];
        if (event.target.name == 'city') {

            slc_munipios = getMunicipios().filter((item_filter: any) => item_filter.padre.toUpperCase() == event.target.value.toUpperCase());

            contact['state'] = null;
            this.setState({
                contact: contact,
                municipios: slc_munipios
            });

        } else {
            this.setState({
                contact: contact
            });
        }

    }

    onChangeForValuesDetailsArray(index: any, e: any) {
        let contact = this.state.contact;
        if (e.target.name == 'shipping_address') {
            let shipping_address_array = contact.shipping_address ? JSON.parse(contact.shipping_address) : [];

            const newArr = shipping_address_array.map((item: any, i: any) => {
                if ((index) == i) {
                    return e.target.value;
                } else {
                    return item;
                }
            });

            contact['shipping_address'] = JSON.stringify(newArr);
            this.setState({
                contact: contact
            });
        }
    }

    render() {
        const { contact, show, formErrors, ModalNotSellShow, fieldsNotSell, departamentos, municipios, rutas } = this.state;
        let render_shipping_address: any = [];
        if (contact) {
            render_shipping_address = this.rendershipping_address(contact)
        }
        return (
            <IonModal onWillDismiss={e => this.onClosenModal()} isOpen={show} trigger="open-modal">
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>{'Datos del Cliente'}</IonTitle>
                        <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.onClosenModal()}>
                            <IonIcon icon={closeOutline}></IonIcon>
                        </IonButton>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">

                    <IonRow>
                        <IonCol col-12 size='12'>
                            <IonList>
                                <IonRow>
                                    <IonCol col-6 size='6'>
                                        <IonCheckbox onIonChange={e => this.handleChange({ target: { name: 'is_contado', value: 1 } })} checked={contact && contact.is_contado && contact.is_contado == 1 ? true : false} labelPlacement="start" alignment="center">
                                            Contado
                                        </IonCheckbox>
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        <IonCheckbox onIonChange={e => this.handleChange({ target: { name: 'is_contado', value: 2 } })} checked={contact && contact.is_contado && contact.is_contado == 2 ? true : false} labelPlacement="start" alignment="center">
                                            Crédito
                                        </IonCheckbox>
                                    </IonCol>
                                </IonRow>
                                <br />
                                {
                                    contact && contact.is_contado && contact.is_contado == 2 ?
                                        <IonRow>
                                            <IonCol col-6 size='6'>
                                                <label>Término de pago: </label>
                                                <input className='inputform' type="text" placeholder="" onChange={this.handleChange.bind(this)} value={(contact && contact.pay_term_number) ?? ""}
                                                    name="pay_term_number" />
                                            </IonCol>
                                            <IonCol col-6 size='6'>
                                                <label>Tipo de Pago</label>
                                                <Select
                                                    className='inputformselect'
                                                    onChange={(e: any) => this.handleChange({ target: { name: 'pay_term_type', value: e.value } })}
                                                    placeholder="Plazo de pago"
                                                    name='pay_term_type'
                                                    menuPortalTarget={document.querySelector('body')}
                                                    isSearchable={false}
                                                    options={[
                                                        { label: 'Seleccione', value: null },
                                                        { label: 'Meses', value: 'months' },
                                                        { label: 'Días', value: 'days' }

                                                    ]}
                                                    styles={{
                                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                    }}
                                                    defaultValue={contact && contact.pay_term_type ?
                                                        contact.pay_term_type == 'months' ?
                                                            { label: 'Meses', value: 'months' }
                                                            : { label: 'Días', value: 'days' }
                                                        : { label: 'Seleccione', value: null }
                                                    }
                                                />
                                            </IonCol>
                                        </IonRow>
                                        : null

                                }
                                <IonCol col-12 size='12'>
                                    <label>Nombre (*): </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={person} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Nombre" onChange={this.handleChange.bind(this)} value={(contact && contact.name) ?? ""} name="name" />
                                    </div>
                                    {formErrors && formErrors.name && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.name}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>

                                <IonCol col-12 size='12'>
                                    <label>Empresa: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={business} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Empresa" onChange={this.handleChange.bind(this)} value={(contact && contact.supplier_business_name) ?? ""}
                                            name="supplier_business_name" />
                                    </div>
                                </IonCol>

                                <IonCol col-12 size='12'>
                                    <label>Celular (*): </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={call} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Celular" onChange={this.handleChange.bind(this)} value={(contact && contact.mobile) ?? ""}
                                            name="mobile" />
                                    </div>
                                    {formErrors && formErrors.mobile && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.mobile}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>

                                <IonCol col-12 size='12'>
                                    <label>RUC / CD: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={barcode} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="RUC / CD" onChange={this.handleChange.bind(this)} value={(contact && contact.tax_number) ?? ""}
                                            name="tax_number" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Codigo de Cliente: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={barcode} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Codigo de Cliente" onChange={this.handleChange.bind(this)} value={(contact && contact.contact_id) ?? ""}
                                            name="contact_id" />
                                    </div>
                                </IonCol>

                                <IonCol col-12 size='12'>
                                    <label>Departamento: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChange({ target: { name: 'city', value: e.value } })}
                                        placeholder="Departamento"
                                        name='city'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={
                                            departamentos && departamentos.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            ))
                                        }
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={contact && contact.city ?
                                            departamentos && departamentos.length > 0 ?
                                                {
                                                    label: departamentos.filter((item: any) => item.id.toUpperCase() == contact.city.toUpperCase())[0].name, value: departamentos.filter((item: any) => item.id.toUpperCase() == contact.city.toUpperCase())[0].id
                                                }
                                                : null
                                            : null
                                        }
                                    />
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Municipio: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChange({ target: { name: 'state', value: e.value } })}
                                        placeholder="Municipio"
                                        name='state'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={
                                            municipios && municipios.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            ))
                                        }
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={contact && contact.state ?
                                            municipios && municipios.length > 0 ?
                                                { label: municipios.filter((item: any) => item.id == contact.state)[0].name, value: municipios.filter((item: any) => item.id == contact.state)[0].id }
                                                : null
                                            : null
                                        }
                                    />
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Barrio: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={barcode} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Barrio" onChange={this.handleChange.bind(this)} value={(contact && contact.country) ?? ""}
                                            name="country" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Dirección: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={home} aria-hidden="true"></IonIcon>
                                        <textarea className='inputform' rows={3} placeholder="Dirección" onChange={this.handleChange.bind(this)} value={(contact && contact.address_line_1) ?? ""}
                                            name="address_line_1" />
                                    </div>
                                </IonCol>
                                {
                                    rutas && rutas.length > 0 ?
                                        <IonCol col-12 size='12'>
                                            <label>Ruta: </label>
                                            <Select
                                                className='inputformselect'
                                                onChange={(e: any) => this.handleChange({ target: { name: 'ruta_id', value: e.value } })}
                                                placeholder="Ruta"
                                                name='ruta_id'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={[
                                                    { label: 'Seleccione', value: null },
                                                    ...(rutas && rutas
                                                        .map((value: any) => ({ label: value.name, value: value.id }))
                                                    )
                                                ]}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={contact && contact.ruta_id ?
                                                    rutas && rutas.length > 0 ?
                                                        {
                                                            label: rutas.filter((item: any) => item.id == contact.ruta_id)[0].name, value: rutas.filter((item: any) => item.id == contact.ruta_id)[0].id
                                                        }
                                                        : { label: 'Seleccione', value: null }
                                                    : { label: 'Seleccione', value: null }
                                                }
                                            />
                                        </IonCol>
                                        : null
                                }
                                <IonCol col-12 size='12'>
                                    <label>Día de visita: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChange({ target: { name: 'day_visit', value: e } })}
                                        placeholder="Día de visita"
                                        name='day_visit'
                                        isMulti
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={[
                                            { label: "Lunes", value: 1 },
                                            { label: "Martes", value: 2 },
                                            { label: "Miercoles", value: 3 },
                                            { label: "Jueves", value: 4 },
                                            { label: "Viernes", value: 5 },
                                            { label: "Sabado", value: 6 },
                                            { label: "Domingo", value: 0 },
                                        ]}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={(contact && contact.day_visit) ?? []}
                                    />
                                </IonCol>

                                <IonCol col-12 size='12'>
                                    <label>Custom1: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field1) ?? ""}
                                            name="custom_field1" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom2: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field2) ?? ""}
                                            name="custom_field2" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom3: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field3) ?? ""}
                                            name="custom_field3" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom4: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field4) ?? ""}
                                            name="custom_field4" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom5: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field5) ?? ""}
                                            name="custom_field5" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom6: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field6) ?? ""}
                                            name="custom_field6" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom7: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field7) ?? ""}
                                            name="custom_field7" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom8: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field8) ?? ""}
                                            name="custom_field8" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom9: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field9) ?? ""}
                                            name="custom_field9" />
                                    </div>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Custom10: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={starHalf} aria-hidden="true"></IonIcon>
                                        <input className='inputform' type="text" placeholder="Custom" onChange={this.handleChange.bind(this)} value={(contact && contact.custom_field10) ?? ""}
                                            name="custom_field10" />
                                    </div>
                                </IonCol>
                                {
                                    render_shipping_address
                                }
                            </IonList>
                        </IonCol>
                    </IonRow>
                </IonContent>
                <IonFooter collapse="fade" className='footerfixed'>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton color="dark" onClick={() => this.onClosenModal()}>
                                Cancel
                            </IonButton>
                        </IonButtons>
                        <IonButtons slot="end">
                            <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                Guardar
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonFooter>
            </IonModal >
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        setData_: PropTypes.func.isRequired,
        post_: PropTypes.func.isRequired,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
        post_: (data: any, controller: string) => dispatch(PosActions.post_(data, controller)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ContactModal);

